import type Phaser from 'phaser';

/**
 * Asset manifest per load group. The asset-pipeline builder generates `public/assets/manifest.json`;
 * until then groups are registered here. Keys are stable asset IDs from docs/ASSET_INVENTORY.json.
 */
export type LoadGroup = 'shared' | 'prologue' | 'green-harbor' | 'turtle-inn' | 'battle';

export interface ManifestEntry { type: 'image' | 'spritesheet' | 'atlas' | 'audio' | 'json' | 'tilemapTiledJSON'; key: string; url: string; frameWidth?: number; frameHeight?: number; atlasUrl?: string }

export const MANIFEST: Record<LoadGroup, ManifestEntry[]> = {
  shared: [],
  prologue: [],
  'green-harbor': [],
  'turtle-inn': [],
  battle: [],
};

/** Runtime manifest generated by tools/assets/build.mjs into public/assets/manifest.json (merged over MANIFEST). */
export interface RuntimeManifest { groups: Partial<Record<LoadGroup, ManifestEntry[]>> }
let runtime: RuntimeManifest | null = null;
export function setRuntimeManifest(m: RuntimeManifest | null): void { runtime = m; }
export function entriesFor(group: LoadGroup): ManifestEntry[] {
  return [...MANIFEST[group], ...(runtime?.groups[group] ?? [])];
}

export function registerManifest(loader: Phaser.Loader.LoaderPlugin, group: LoadGroup): void {
  for (const e of entriesFor(group)) {
    switch (e.type) {
      case 'image': loader.image(e.key, e.url); break;
      case 'spritesheet': loader.spritesheet(e.key, e.url, { frameWidth: e.frameWidth ?? 32, frameHeight: e.frameHeight ?? 48 }); break;
      case 'atlas': loader.atlas(e.key, e.url, e.atlasUrl ?? e.url.replace(/\.png$/, '.json')); break;
      case 'audio': loader.audio(e.key, e.url); break;
      case 'json': loader.json(e.key, e.url); break;
      case 'tilemapTiledJSON': loader.tilemapTiledJSON(e.key, e.url); break;
    }
  }
}
